import c1 from "assets/img/posts/c1.jpg";
import c2 from "assets/img/posts/c2.jpg";
import c3 from "assets/img/posts/c3.jpg";
import c4 from "assets/img/posts/c4.jpg";
import { useDispatch } from "react-redux";
import { openLightBox } from "services/redux/lightbox/lightbox";
import { AppDispatch } from "services/redux/store";

const PostMedia4 = () => {
    const dispatch = useDispatch<AppDispatch>();
    return (
        <div className="post-image quad-img">
            <div className="masonry-grid flex-j-center gap-10">
                {/* <!-- Left column --> */}
                <div
                    className="masonry-column-left  d-flex flex-col flex-j-center gap-15"
                    style={{ width: "45%" }}
                >
                    <div className=" cursor-pointer">
                        <img
                            src={c1}
                            // src="https://via.placeholder.com/1600x900"
                            // data-demo-src="assets/img/demo/unsplash/3.jpg"
                            alt=""
                            onClick={() => dispatch(openLightBox())}
                        />
                    </div>
                    <div className=" cursor-pointer">
                        <img
                            src={c2}
                            // src="https://via.placeholder.com/1600x900"
                            // data-demo-src="assets/img/demo/unsplash/4.jpg"
                            alt=""
                            onClick={() => dispatch(openLightBox())}
                        />
                    </div>
                </div>
                {/* <!-- Right column --> */}
                <div
                    className="masonry-column-right  d-flex flex-col flex-j-center gap-15"
                    style={{ width: "45%" }}
                >
                    <div className=" cursor-pointer">
                        <img
                            src={c3}
                            // src="https://via.placeholder.com/1600x1900"
                            // data-demo-src="assets/img/demo/unsplash/5.jpg"
                            alt=""
                            onClick={() => dispatch(openLightBox())}
                        />
                    </div>
                    <div className=" cursor-pointer">
                        <img
                            src={c4}
                            // src="https://via.placeholder.com/1600x900"
                            // data-demo-src="assets/img/demo/unsplash/6.jpg"
                            alt=""
                            onClick={() => dispatch(openLightBox())}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PostMedia4;
